'use client';

import classnames from 'classnames';

interface Props {
  block?: boolean;
  children: string;
  disabled?: boolean;
  onClick?: () => void;
  right?: boolean;
  type?: 'submit' | 'reset' | 'button' | undefined;
}

const Button = ({
  block = false,
  children,
  disabled = false,
  onClick = undefined,
  right = false,
  type = 'button',
}: Props) => {
  const className = classnames({
    border: true,
    'border-button-border-color': true,
    'p-1.5': true,
    rounded: true,
    'bg-button-background-color': true,
    'text-button-text-color': true,
    'focus:outline-none': true,
    'active:outline-none': true,
    'hover:outline-none': true,
    'disabled:!opacity-60': true,
    'disabled:!border': true,
    'w-full': block,
    'float-right': right,
  });

  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={className}
    >
      {children}
    </button>
  );
};

export default Button;
